/*
 * Le nom d'une étape de plan en mots, partout pareil (fiche de commande, portail technicien, dossier d'inscription) :
 * sa description quand le serveur la donne, sinon son nom dans l'une des listes connues, sinon « une étape », jamais
 * son nom technique.
 */
const NAME_KEYS = ['commissioning.step.', 'onboarding.step.', 'onboarding.plan-step.']

export function planStepName(vm, step) {
  if (step?.description && vm.$te(step.description)) return vm.$t(step.description, step.params || {})
  const name = typeof step === 'string' ? step : step?.name
  for (const prefix of NAME_KEYS) {
    if (name && vm.$te(prefix + name)) return vm.$t(prefix + name, (typeof step === 'object' && step?.params) || {})
  }
  return vm.$t('onboarding.plan-step.unknown')
}

/** La raison d'un échec : traduite par le serveur (`reasonLabel`), sinon par l'écran, sinon telle que dite. */
export function planReason(vm, reason, params, label = null) {
  if (label) return label
  if (!reason) return ''
  return vm.$te(reason) ? vm.$t(reason, params || {}) : reason
}
